import React from 'react';
import '../CSS/Profile/JeanCallaghanProfile.css';

const JeanCallaghanProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/jean-callaghan-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Jean Callaghan"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Jean Callaghan</h1>
        <div className="profile-title-container">
          <p className="profile-title">Coordinator of Information Technology</p>
          <img 
            src={linkedInIcon}
            alt="LinkedIn"
            className="profile-linkedin-icon"
          />
        </div>
        <div className="profile-desc">
          <p>
            Jean Callaghan joined Myers McRae as Coordinator of Information of Technology in 2010. She assists in identifying qualified prospects, especially for searches that require special qualifications or that are for emerging areas of study.
          </p>
          <p>
            Ms. Callaghan gained extensive expertise in researching prospects during her 30-year career in recruiting for non-profits, corporations, and professional services firms. A certified personnel consultant, she served on the Board of Directors of the Georgia Association of Personnel Services for many years and was a member of its Million Dollar Hall of Fame.
          </p>
          <p>
            In addition to her work in higher education, Ms. Callaghan has search expertise in sourcing top talent for the pulp and paper industry, hydraulic and heavy equipment, chemical processing, construction and mining equipment, the beverage industry, and consulting firms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default JeanCallaghanProfile;

